import {StructuredDataContent} from 'rlink-repos/content';

export default class Franchise extends StructuredDataContent {
  static get contentIcon () {
    return 'picture-o';
  }

  static defaultData () {
    return {
      priority: 0,
      games: [],
      parallaxImages: [],
    };
  }

  get adminLabel () {
    return `${(this.title) ? this.title : 'NEW'} - Franchise`;
  }

  get priority () {
    return this.data.get('priority', this.constructor.defaultData().priority);
  }

  get title () {
    return this.data.get('title');
  }

  get games () {
    return this.data.get('games', this.constructor.defaultData().games);
  }

  get parallaxImages () {
    return this.data.get('parallaxImages', this.constructor.defaultData().parallaxImages)
      .map(img => Object.assign(img.toJS(), {
        formats: [
          {contentType: 'image/webp', fileExt: 'webp'},
          {contentType: 'image/jpeg', fileExt: 'jpg'},
        ],
        src: img.get('imagePath', img.get('src')),
        widths: [
          2560, 1920, 1680, 1366, 1024, 800, 568, 480, 420, 320,
        ],
      }));
  }

  get mobileImagePath () {
    return this.data.get('mobileImagePath', '');
  }

  get description () {
    return this.data.get('description', '');
  }

  get link () {
    return this.data.get('link', '');
  }

  get quote () {
    return this.data.get('quote', '');
  }

  get quoteAuthor () {
    return this.data.get('quoteAuthor', '');
  }

  get quoteLink () {
    return this.data.get('quoteLink', '');
  }

  get esrb () {
    return this.data.get('esrb', '');
  }
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/content-types/Franchise.js